export interface AssessmentQuestion {
  id: number;
  category: string;
  question: string;
  responses: string[];
  scores?: number[];
  conditionalOn?: number;
  conditionalResponse?: string;
}

export const aiDigitalTransformationData: AssessmentQuestion[] = [
  // Profil entreprise
  {
    id: 1,
    category: "Profil entreprise",
    question: "Quel est le secteur principal de votre activité ?",
    responses: ["Industrie", "Services", "Éducation", "Santé", "Public", "Autres"]
  },
  {
    id: 2,
    category: "Profil entreprise", 
    question: "Combien de salariés compte votre entreprise ?",
    responses: ["<10", "10-50", "51-200", "201-1000", ">1000"]
  },
  {
    id: 3,
    category: "Profil entreprise",
    question: "Votre entreprise est-elle multi-sites ?",
    responses: ["Oui", "Non"]
  },
  
  // Organisation & culture
  {
    id: 4,
    category: "Organisation & culture",
    question: "Existe-t-il un système de gouvernance (comité, centre d'excellence) autour de l'IA dans l'entreprise ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 5,
    category: "Organisation & culture",
    question: "Existe-t-il un responsable pilote IA désigné dans l'entreprise ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 6,
    category: "Organisation & culture",
    question: "Le top management est-il engagé sur les sujets IA ?",
    responses: ["Oui", "Moyennement", "Faiblement", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 7,
    category: "Organisation & culture",
    question: "Comment qualifieriez-vous la culture data/IA de vos équipes ?",
    responses: ["Très avancée", "Moyenne", "Faible", "Inexistante", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 8,
    category: "Organisation & culture",
    question: "Les équipes sont-elles sensibilisées aux enjeux de l'IA ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 9,
    category: "Organisation & culture",
    question: "Des référents IA sont-ils désignés pour promouvoir les outils/pratiques dans chaque service ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  
  // Digitalisation & outils
  {
    id: 10,
    category: "Digitalisation & outils",
    question: "Comment décririez-vous la maturité digitale de votre entreprise ?",
    responses: ["Avancée", "En transition", "Faible", "Inexistante", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 11,
    category: "Digitalisation & outils",
    question: "Disposez-vous d'outils déjà intégrés avec des fonctionnalités IA ?",
    responses: ["Oui, de manière native", "Oui, partiellement", "En test", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 12,
    category: "Digitalisation & outils",
    question: "Comment sont structurées vos données ?",
    responses: ["Centralisées", "Dispersées mais accessibles", "Dispersées", "Très cloisonnées", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 13,
    category: "Digitalisation & outils",
    question: "Les données sont-elles facilement accessibles par les équipes métier ?",
    responses: ["Oui", "Partiellement", "Avec difficulté", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 14,
    category: "Digitalisation & outils",
    question: "Avez-vous un système de contrôle qualité des données ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 15,
    category: "Digitalisation & outils",
    question: "Êtes-vous conforme aux exigences RGPD sur les données utilisées ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  
  // Communication & Compétences
  {
    id: 16,
    category: "Communication & Compétences",
    question: "Une communication sur l'IA (actualité sectorielle, stratégie de l'entreprise, etc.) est-elle partagée dans l'organisation ?",
    responses: ["Oui, régulièrement", "Oui, ponctuellement", "Rarement", "Jamais", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 17,
    category: "Communication & Compétences",
    question: "Avez-vous formé vos collaborateurs aux enjeux de l'IA ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 18,
    category: "Communication & Compétences",
    question: "Avez-vous recruté des profils spécialisés IA ou data ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 19,
    category: "Communication & Compétences",
    question: "Les craintes ou réticences face à l'IA (évolution des compétences, éthique, sécurité...) sont-elles prises en compte ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 20,
    category: "Communication & Compétences",
    question: "Les collaborateurs disposent-ils de temps pour expérimenter des outils IA ?",
    responses: ["Oui", "Occasionnellement", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  
  // Sécurité & conformité
  {
    id: 21,
    category: "Sécurité & conformité",
    question: "Avez-vous identifié des risques liés à l'IA ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 22,
    category: "Sécurité & conformité",
    question: "Un cadre d'usage de l'IA est-il défini dans votre organisation ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 23,
    category: "Sécurité & conformité",
    question: "Avez-vous déjà une équipe dédiée à la cybersécurité liée à l'IA ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 24,
    category: "Sécurité & conformité",
    question: "Les données que vous utiliserez avec l'IA sont-elles déjà qualifiées (vérifiées/validées) ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  
  // Maturité IA
  {
    id: 25, // Question à réponses multiples
    category: "Maturité IA",
    question: "Utilisez-vous déjà des outils IA ?",
    responses: ["LLM via API", "Agents conversationnels (relation client, coaching, etc)", "Agents IA (Manus, AutoGpt, etc.)", "IA copilote (Microsoft 365 Copilot, Breeze, etc.)", "Outils spécialisés (Noota, Heygen, D-ID, etc.)","Aucun", "Ne sais pas"]
  },
  {
    id: 26,
    category: "Maturité IA",
    question: "Si oui, ces outils IA sont-ils utilisés par vos collaborateurs au quotidien ?",
    responses: ["Systématiquement", "Régulièrement", "Rarement", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 27,
    category: "Maturité IA",
    question: "Avez-vous déjà déployé des projets IA pilotes ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  
  // Questions conditionnelles (si question 27 === "Oui")
  {
    id: 28,
    category: "Maturité IA",
    question: "Les projets IA incluent-ils des équipes pluridisciplinaires ?",
    responses: ["Oui, dès la phase de conception", "Parfois", "Rarement", "Jamais", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0],
    conditionalOn: 27,
    conditionalResponse: "Oui"
  },
  {
    id: 29,
    category: "Maturité IA", 
    question: "Les résultats des projets IA sont-ils évalués régulièrement ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0],
    conditionalOn: 27,
    conditionalResponse: "Oui"
  },
  {
    id: 30,
    category: "Maturité IA",
    question: "Avez-vous mis en place des KPIs pour suivre vos projets IA ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0],
    conditionalOn: 27,
    conditionalResponse: "Oui"
  },
  {
    id: 31,
    category: "Maturité IA",
    question: "Avez-vous mesuré un impact mesurable (gains, efficacité, etc.) ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0],
    conditionalOn: 27,
    conditionalResponse: "Oui"
  },

  
  // Vision IA
  {
    id: 32,// Question à réponses multiples
    category: "Vision IA",
    question: "Quels domaines vous semblent les plus pertinents pour l'IA ?",
    responses: ["Ventes", "RH", "Formation", "Production", "Finance", "Autres"]
  },
  {
    id: 33,
    category: "Vision IA",
    question: "Avez-vous déjà identifié des cas d'usage IA à forte valeur ajoutée spécifiques à votre activité ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
    id: 34,
    category: "Vision IA",
    question: "Une stratégie claire d'intégration de l'IA existe-t-elle au sein de votre entreprise ?",
    responses: ["Oui", "En cours", "En réflexion", "Non", "Ne sais pas"],
    scores: [3, 2, 1, 0, 0]
  },
  {
   id: 35,
   category: "Vision IA",
   question: "Quel est votre niveau d'ambition IA à 2 ans ?",
   responses: ["Très ambitieux", "Modéré", "Opportuniste", "En observation", "Ne sais pas"],
   scores: [3, 2, 1, 0, 0]
  }
];

// Mapping des catégories pour l'affichage
export const categoryMapping = {
  "Organisation & culture": "Organisation & culture",
  "Digitalisation & outils": "Digitalisation & outils", 
  "Communication & Compétences": "Communication & Compétences",
  "Sécurité & conformité": "Sécurité & conformité",
  "Maturité IA": "Maturité IA",
  "Vision IA": "Vision IA"
};

export const categoryExplanations = {
  "Profil entreprise": "Cette dimension permet de contextualiser votre évaluation selon votre secteur d'activité, taille et organisation.",
  "Organisation & culture": "Cette dimension évalue la maturité organisationnelle et culturelle de votre entreprise face à l'IA, incluant la gouvernance et l'engagement du management.",
  "Digitalisation & outils": "Cette dimension analyse le niveau actuel de digitalisation de votre entreprise.",
  "Communication & Compétences": "Cette dimension analyse la communication interne sur l'IA et le développement des compétences de vos collaborateurs.",
  "Sécurité & conformité": "Cette dimension évalue votre préparation aux enjeux de sécurité, de risques et de conformité liés à l'usage de l'IA.",
  "Maturité IA": "Cette dimension évalue votre usage actuel des outils d'intelligence artificielle dans la conception et la production de formations.",
  "Vision IA": "Cette dimension analyse votre vision stratégique et vos projets concrets d'intégration de l'IA dans votre politique formation."
};
